/**
 * Query parameters that are credentials, not context.
 *
 * `oobCode` is the Firebase action code from a password reset or email
 * verification link. Anyone holding it can set the account's password, so it
 * must never reach an analytics or error-reporting vendor.
 *
 * `code` and `state` arrive on the QuickBooks and Shopify OAuth callbacks
 * (`/connection/qbo`, `/connection/shopify`): the authorization code and the
 * CSRF token that guards its exchange.
 */
const SECRET_PARAMS = ["oobcode", "apikey", "code", "state"];

/** Replaces credential query parameters with REDACTED, leaving the rest. */
export function redactSensitiveUrl(url: string): string;
export function redactSensitiveUrl(url: undefined): undefined;
export function redactSensitiveUrl(url?: string): string | undefined;
export function redactSensitiveUrl(url?: string): string | undefined {
	if (!url) return url;
	try {
		const parsed = new URL(url, window.location.origin);
		let touched = false;
		for (const key of [...parsed.searchParams.keys()]) {
			if (!SECRET_PARAMS.includes(key.toLowerCase())) continue;
			parsed.searchParams.set(key, "REDACTED");
			touched = true;
		}
		return touched ? parsed.toString() : url;
	} catch {
		// Not a parsable URL. Better to pass it through than to lose the context.
		return url;
	}
}
